<template>
    <v-container>
        <v-card min-width="100%">
            <v-card-title>
                {{ title }}
            </v-card-title>
            <v-form v-model="valid">
                <v-card-text>

                    <v-row>
                        <v-col cols="6" md="6">


                    <error-badge :value="error" ref="errors"></error-badge>

                    <v-container v-if="errors.length > 0">
                        <div class="alert alert-danger">
                            <ul>
                                <li v-for="(error, ierr) in errors" :key="ierr">{{ error }}</li>
                            </ul>
                        </div>
                    </v-container>
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12">
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" v-if="data.creator.name !== undefined">
                                {{ trans('targets.fields.creator')  }} : {{ data.creator.name }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6" v-if="data.approvedDate != null">
                                    {{ trans('targets.fields.approved')  }} : {{ data.approvedDate | dateTimeISO }}
                            </v-col>
                            <v-col cols="6" md="6" v-if="data.approvedDate != null && data.approver.name !== undefined">
                                    {{ trans('targets.fields.approver')  }} : {{ data.approver.name }}
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12">
                            </v-col>
                        </v-row>
                        <!--
                        <v-row>
                            <v-col cols="12" md="12" class="formSection">
                                {{ trans('targets.fields.author') }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="formSection">
                                {{ trans('targets.fields.detail') }}
                            </v-col>
                        </v-row>
                        -->
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-textarea v-model="data.name" :label="trans('targets.fields.name') + '*'" :counter="255"
                                    :rules="FormRuleHelper.stringRule(data.name, true, 3, 255)" required id="name"
                                    name="name">
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-text-field v-model="data.deadline" :label="trans('targets.fields.deadline') + '*'"
                                    type="date" :rules="FormRuleHelper.requireRule(data.deadline)" required id="deadline"
                                    name="deadline">
                                </v-text-field>
                            </v-col>

                            <!--
                            <v-col cols="6" md="6">
                                <v-select :items="types" :label="trans('targets.fields.type') + '*'" :value="'W'"
                                    v-model="data.type" required id="type" name="type"></v-select>
                            </v-col>
                            -->
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <v-select :items="priorities" :label="trans('targets.fields.priority') + '*'" required
                                    id="priority" name="priority" v-model="data.priority"
                                    :item-text="'text'"
                                    :item-value="'value'"
                                    :rules="FormRuleHelper.requireRule(data.priority)">
                                </v-select>
                            </v-col>

                            <v-col cols="6" md="6" v-if="data.activities.length == 0">
                                <v-text-field v-model="data.hourly_budget"
                                    :label="trans('targets.fields.hourly_budget')+'*'" type="number"
                                    :rules="FormRuleHelper.numericRule(data.hourly_budget, (data.activities.length == 0), 0)" id="hourly_budget"
                                    name="hourly_budget">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="inputBlock">
                                <v-textarea v-model="data.description" :label="trans('targets.fields.description')" style="height: 275px;"
                                    :rules="FormRuleHelper.stringRule(data.description, false, null, 255)" :counter="255"
                                    id="description" name="description"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <small><b>*</b>&nbsp;{{ trans('common.required-field') }}</small>

                        </v-row>


                    </v-container>
                    </v-col>
                    <v-col cols="6" md="6">
                        <target-calendar :target_calendar_action="target_calendar_action"></target-calendar>
                    </v-col>
                </v-row>
                    <v-container>
                        <v-row>
                            <v-col cols="6" md="6">
                                {{ trans('targets.fields.allocated_time') }} : {{ sum_activities_allocated_time }}
                            </v-col>
                        </v-row>
                        <v-row>

                            <v-col cols="6" md="6">
                                <select-item :disabled="freeze_company == '1'" :hidden="freeze_company == '1'"
                                    :label="trans('targets.fields.company_id') + '*'" :item-text="'name'"
                                    :action="company_search_action"
                                    v-model="company"
                                    :rules="FormRuleHelper.requireRule(company)"
                                    @input="componentKey=!componentKey"

                                    >
                                </select-item>

                            </v-col>
                            <v-col cols="6" md="6" v-if="company && company.id && users_division_search_action !== ''">
                                <item-selector :key="componentKey"
                                    :label="trans('targets.fields.assigned_users')"
                                    :item-text="'name'"
                                    :action="company_division_search_action"
                                    v-model="data.users_divisions"
                                    :multiple="true"
                                    :required="true"
                                    :clearable="true"
                                    :preload="true"
                                    >
                            </item-selector>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="formSubSection">
                                {{ trans('targets.fields.activities') }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>{{ trans('activities.fields.name') }}</th>
                                                <th>{{ trans('activities.fields.deadline') }}</th>
                                                <th>{{ trans('activities.fields.allocated_time') }}</th>
                                                <th> Op. </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(activity, aid) in data.activities">
                                                <td>{{ activity.name }}</td>
                                                <td>{{ activity.deadline | date }}</td>
                                                <td>{{ activity.allocated_time }}</td>
                                                <td>
                                                    <activity-edit :key="aid" :activity="activity"
                                                        :open_dialog="last_added_activity_open_dialog(activity)"
                                                        @removeActivity="removeActivity(activity)"
                                                        >
                                                    </activity-edit>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-btn class="mt-3" color="primary" @click="addActivity()">
                                    {{ trans('activities.actions.add') }}
                                    <v-icon right>add</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row v-if="manageApproved()">

                            <v-col cols="6" md="6">
                                <v-btn v-if="data.isApproved == 1" @click="data.isApproved = 0" color="success">
                                    <v-icon left>check_box</v-icon>{{ trans('targets.actions.approve') }}
                                </v-btn>
                                <v-btn v-if="data.isApproved == 0" @click="data.isApproved = 1" color="error">
                                    <v-icon left>check_box_outline_blank</v-icon>{{ trans('targets.actions.approve') }}
                                </v-btn>
                                &nbsp;&nbsp;
                                <span v-if="data.isApproved == 1" color="success">{{trans('targets.fields.approved')}}</span>
                                <span v-else color="error">{{trans('targets.fields.disapproved')}}</span>

                            </v-col>
                        </v-row>
                    </v-container>

                </v-card-text>
                <v-card-actions>
                    <a :href="cancel_action">
                        <v-btn color="gray">
                            <v-icon right>arrow_back</v-icon>&nbsp; {{ trans('users_targets_progressions.actions.cancel') }}
                        </v-btn>
                    </a>
                    <v-spacer>
                    </v-spacer>
                    <v-btn @click="submit" :disabled="!canSubmit" color="primary">
                        <v-icon left>send</v-icon>{{ trans('targets.actions.save') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-container>
</template>
<script>

import FormRuleHelper from '../../../FormRuleHelpers.js';
import ActivityEdit from '../Activity/ActivityEdit.vue';
import TargetCalendar from './TargetCalendar.vue';

export default {

    name: "target-edit",
    props: {

        title: { default: '' },
        target: { type: Object },
        freeze_company: {default: false},
        form_errors: { default: [] },
        form_action: { default: '' },
        form_method: { default: '' },
        company_search_action: { default: '' },
        users_division_search_action: { default: '' },
        cancel_action: { default: ''},
        target_calendar_action: { default: ''}


    },

    data() {

        //let data = {}; // todo - add default schema
        //data = Object.assign(data, this.target || {});

        let data = this.target;

        let errors = Object.entries(this.form_errors);
        let error = null;
        let company = null;

        if(data.company) {
            company = {
                id: data.company.id,
                name: data.company.name
            };
        }

        let last_added_activity = {};


        return {
            data,
            FormRuleHelper,
            errors: errors,
            error,
            open_dialog: false,
            changed: false,
            valid: false,
            //priorities: ['1', '2', '3'],
            priorities: [
                {'text': trans('targets.values.priority.1'), 'value': '1'},
                {'text': trans('targets.values.priority.2'), 'value': '2'},
                {'text': trans('targets.values.priority.3'), 'value': '3'},
            ],
            //types: ['P', 'W'],
            types: [
                {'text': trans('targets.values.type.P'), 'value': 'P'},
                {'text': trans('targets.values.type.W'), 'value': 'W'}

            ],
            loading: false,
            company,
            last_added_activity,
            componentKey: 0,


        };
    },

    methods: {

        manageApproved() {
            if(this.data.type == 'P') {
                this.data.isApproved = 0;
            }

            if(this.form_method == 'post') {

                if(this.data.type == 'W') {
                    this.data.isApproved = 1;
                } else {
                    this.data.isApproved = 0;
                }
            }



            return (this.data.type == 'W');


        },


        addActivity() {

            let activity = {
                name: null,
                description: null,
                deadline: null,
                allocated_time: null,
                target_id: this.data.id,
                hasUserActivity: false
            };

            this.data.activities.push(activity);
            this.open_dialog = true;
            this.last_added_activity = activity;
        },

        removeActivity(activity) {

            this.last_added_activity = {};
            let index = this.data.activities.indexOf(activity);
            if (index > -1) {
                this.data.activities.splice(index, 1);
                this.$emit("removeActivity", this.data.activities);
            }
        },

        last_added_activity_open_dialog(activity) {

            if(activity == this.last_added_activity) {
                return this.open_dialog;
            }

            return false;

        },



        async submit() {

            window.onbeforeunload = true;
            this.error = null;
            this.loading = true;

            this.data.company_id = this.company.id;

            if(this.form_method == 'post') {
                return await this.postData();
            }

            if(this.form_method == 'put') {
                return await this.putData();
            }



        },

        async postData() {

            let url = this.form_action;


            await axios.post(
                url,
                this.data,
            )
                .then((response) => {
                    if (response.data && response.data.status == 'ok' && response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch((error) => {

                    this.error = error.response.data.errors;
                })
                .finally(() => {
                    this.loading = false;
                });

        },

        async putData() {

            let url = this.form_action;

            await axios.put(
                url,
                this.data,
            )
                .then((response) => {
                    if (response.data && response.data.status == 'ok' && response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch((error) => {
                    this.error = error.response.data.errors;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

    },

    computed: {
        canSubmit() {
            return this.changed && this.valid;
        },

        company_division_search_action() {
            let action_route = this.users_division_search_action;
            if(this.company.id !== null) {
                action_route = action_route + '/' + this.company.id;
            }
            return action_route;

        },

        sum_activities_allocated_time() {

            let allocated_time = 0;

            for (let index in this.data.activities) {

                let activity = this.data.activities[index];
                if(activity.allocated_time !== null) {
                    allocated_time = parseInt(allocated_time) + parseInt(activity.allocated_time);
                }

            }
            this.data.hourly_budget =  allocated_time > 0 ? allocated_time : (this.data.hourly_budget > 0 ? this.data.hourly_budget : null);
            return allocated_time;


        },


    },


    watch: {

        data: {
            deep: true,
            handler() {
                this.changed = true;
            }
        },

        company: {

            handler() {
                this.data.company_id = this.company?.id;
                this.changed = true;
                this.data.users_divisions = [];
            }

        }

    },

    /*
    watch: {
        data: {
            handler: function (newValue) {
                this.changed = true;

                window.onbeforeunload = function (e) {
                    return trans('common.confirm-exit-page');
                };
            },
            deep: true
        },
    },
    */


    components: {
        ActivityEdit,
        TargetCalendar
    }

}
</script>
